<template>
  <div v-if="!selecionouRespostaIpi">
    <div class="ipi-respostas-container" v-for="alerta in alertasFiltrados">
      <QuadroAlertaZfm :alerta="alerta" />
    </div>
    <div class="ipi-respostas-container" v-for="resposta in respostaFiltrada">
      <RadioButton
        v-if="respostaFiltrada.length > 1 && resposta.ordem != 101"
        :classe="imposto.classe"
        :seleciona="seleciona"
        :imposto="resposta"
      />

      <Registro
        v-if="!resposta.blSimplesNacional"
        :paddingSemCheckBox="respostaFiltrada.length <= 1"
      >
        <Cabecalho
          :tipo="'porcentagem2'"
          :titulo="
            resposta.label && resposta.label != 'Alíquota'
              ? resposta.label
              : resposta.aliquota_efetiva
              ? 'Alíquota Efetiva'
              : 'Alíquota'
          "
          :aliquota="
            resposta.label == 'Não tributada'
              ? 'NT'
              : resposta.aliquota_efetiva
              ? resposta.aliquota_efetiva
              : resposta.aliquota
          "
        />

        <SubRegistro
          class="reducao-container"
          v-if="!!resposta.aliquota_efetiva && resposta.tipo_red"
          :classe="imposto.classe"
        >
          <Cabecalho :titulo="'Alíquota'" :aliquota="resposta.aliquota" />
          <div class="separador" />

          <Cabecalho
            v-if="resposta.red_aliquota"
            :titulo="`Redução de alíquota ${resposta.tipo_red.toLowerCase()}:`"
            :aliquota="resposta.red_aliquota"
          />
          <Cabecalho
            v-if="resposta.red_aliquota_outra"
            :titulo="`Redução de alíquota ${resposta.tipo_red.toLowerCase()}:`"
            :aliquota="resposta.red_aliquota_outra"
          />
        </SubRegistro>
        <SubRegistro
          class="reducao-container"
          v-else-if="resposta.label == 'Pauta Mínima' && resposta.red_aliquota"
          :classe="imposto.classe"
        >
          <Cabecalho :titulo="'Alíquota'" :aliquota="resposta.aliquota" />
          <div class="separador" />

          <Cabecalho
            v-if="resposta.red_aliquota"
            :titulo="`Redução de alíquota `"
            :aliquota="resposta.red_aliquota"
          />
          <Cabecalho
            v-if="resposta.red_aliquota_outra"
            :titulo="`Redução de alíquota`"
            :aliquota="resposta.red_aliquota_outra"
          />
        </SubRegistro>
        <Separador :dado="resposta" />

        <Ncm v-if="resposta.label != 'Não tributada'" :ncm="resposta.ncm" />
        <div v-if="resposta.label != 'Não tributada' && !!resposta.ncm" class="separador" />

        <Descricao :titulo="'Descrição'" :descricao="resposta.descricao" />

        <GrupoNotificacao v-if="resposta" :registro="resposta" />
        <Notificacao v-if="resposta.alerta" :tipo="'alerta'" :texto="resposta.alerta" />

        <Separador
          v-if="
            !!resposta.descricao ||
              !!resposta.obs ||
              !!resposta.obs_aplic ||
              !!resposta.obs_inaplic ||
              !!resposta.alerta
          "
          :dado="resposta"
        />

        <BaseLegal :base_legal="resposta.base_legal" :classe="imposto.classe" />
      </Registro>
      <Registro
        v-if="!!resposta.blSimplesNacional"
        :paddingSemCheckBox="respostaFiltrada.length <= 1"
      >
        <IpiSimplesNacional :imposto="imposto" :registro="resposta" />
      </Registro>
    </div>
  </div>
  <div v-else>
    <div class="ipi-respostas-container" v-for="alerta in alertasFiltrados">
      <QuadroAlertaZfm :alerta="alerta" />
    </div>

    <div class="ipi-respostas-container">
      <EditButton v-if="respostaFiltrada.length > 1" :classe="imposto.classe" :edita="edita" />
      <Registro
        v-if="!respostaSelecionada.blSimplesNacional"
        :paddingSemCheckBox="respostaFiltrada.length <= 1"
      >
        <Cabecalho
          :tipo="'porcentagem2'"
          :titulo="
            respostaSelecionada.label && respostaSelecionada.label != 'Alíquota'
              ? respostaSelecionada.label
              : respostaSelecionada.aliquota_efetiva
              ? 'Alíquota Efetiva'
              : 'Alíquota'
          "
          :aliquota="
            respostaSelecionada.label == 'Não tributada'
              ? 'NT'
              : respostaSelecionada.aliquota_efetiva
              ? respostaSelecionada.aliquota_efetiva
              : respostaSelecionada.aliquota
          "
        />

        <SubRegistro
          class="reducao-container"
          v-if="!!respostaSelecionada.aliquota_efetiva && respostaSelecionada.tipo_red"
          :classe="imposto.classe"
        >
          <Cabecalho :titulo="'Alíquota'" :aliquota="respostaSelecionada.aliquota" />
          <div class="separador" />

          <Cabecalho
            v-if="respostaSelecionada.red_aliquota"
            :titulo="`Redução de alíquota ${respostaSelecionada.tipo_red.toLowerCase()}:`"
            :aliquota="respostaSelecionada.red_aliquota"
          />
          <Cabecalho
            v-if="respostaSelecionada.red_aliquota_outra"
            :titulo="`Redução de alíquota ${respostaSelecionada.tipo_red.toLowerCase()}:`"
            :aliquota="respostaSelecionada.red_aliquota_outra"
          />
        </SubRegistro>
        <SubRegistro
          class="reducao-container"
          v-else-if="
            respostaSelecionada.label == 'Pauta Mínima' && respostaSelecionada.red_aliquota
          "
          :classe="imposto.classe"
        >
          <Cabecalho :titulo="'Alíquota'" :aliquota="respostaSelecionada.aliquota" />
          <div class="separador" />

          <Cabecalho
            v-if="respostaSelecionada.red_aliquota"
            :titulo="`Redução de alíquota`"
            :aliquota="respostaSelecionada.red_aliquota"
          />
          <Cabecalho
            v-if="respostaSelecionada.red_aliquota_outra"
            :titulo="`Redução de alíquota`"
            :aliquota="respostaSelecionada.red_aliquota_outra"
          />
        </SubRegistro>
        <Separador :dado="respostaSelecionada" />

        <Ncm v-if="respostaSelecionada.label != 'Não tributada'" :ncm="respostaSelecionada.ncm" />
        <div
          v-if="respostaSelecionada.label != 'Não tributada' && !!respostaSelecionada.ncm"
          class="separador"
        />

        <Descricao :titulo="'Descrição'" :descricao="respostaSelecionada.descricao" />

        <GrupoNotificacao v-if="respostaSelecionada" :registro="respostaSelecionada" />
        <Notificacao v-if="respostaSelecionada.alerta" :tipo="'alerta'" :texto="respostaSelecionada.alerta" />

        <Separador
          v-if="
            !!respostaSelecionada.descricao ||
              !!respostaSelecionada.obs ||
              !!respostaSelecionada.obs_aplic ||
              !!respostaSelecionada.obs_inaplic ||
              !!respostaSelecionada.alerta
          "
          :dado="respostaSelecionada"
        />

        <BaseLegal :base_legal="respostaSelecionada.base_legal" :classe="imposto.classe" />
      </Registro>
      <Registro
        v-if="!!respostaSelecionada.blSimplesNacional"
        :paddingSemCheckBox="respostaFiltrada.length <= 1"
      >
        <IpiSimplesNacional :imposto="imposto" :registro="respostaSelecionada" />
      </Registro>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Memoria from "../Memoria/Memoria.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import SubRegistro from "@/components/SubRegistro/SubRegistro.vue";
import IpiSimplesNacional from "../IpiSimplesNacional/IpiSimplesNacional.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";
import QuadroAlertaZfm from "@/components/QuadroAlertaZfm/QuadroAlertaZfm.vue";

export default {
  name: "RespostasIpi",

  props: {
    imposto: Object | Array,
    seleciona: Function,
    edita: Function,
    respostaSelecionada: Object,
    selecionouRespostaIpi: Boolean
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    RadioButton,
    Registro,
    Separador,
    Memoria,
    GrupoNotificacao,
    Ncm,
    Notificacao,
    SubRegistro,
    IpiSimplesNacional,
    QuadroAlertaZfm
  },

  created() {
    // se tiver apenas um resultado, seleciona o mesmo.
    if (this.imposto && this.respostaFiltrada.length == 1) {
      this.seleciona(this.respostaFiltrada[0]);
    }
  },
  updated() {
    // se tiver apenas um resultado, seleciona o mesmo.
    if (this.imposto && this.respostaFiltrada.length == 1) {
      this.seleciona(this.respostaFiltrada[0]);
    }
  },

  computed: {
    alertaZfm() {
      return this.imposto.dados.find(resposta => resposta.ordem == 101);
    },
    respostaFiltrada() {
      return this.imposto.dados.filter(imposto => imposto.ordem != 101);
    },
    alertasFiltrados() {
      return this.imposto.dados.filter(imposto => imposto.ordem == 101);
    }
  }
};
</script>

<style lang="scss" scoped>
.ipi-respostas-container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}

.reducao-container {
  margin: 0.5rem 0;
}
</style>
